import { Button, Form, Input } from "antd";
import { FORMDATA } from "constants/Data";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store";
import { addRoleActionTable, cloneRoleActionTable, editRoleActionTable } from "../../../../redux/actions/roleTableAction";
import styles from "./index.module.scss";
import "./index.scss";
import { SideDrawerBodyProps } from "./types";
import { toastText } from "utils/utils";


const AddRoleBody: FC<SideDrawerBodyProps> = (props) => {
  const {
    closeDrawerByAnimation,
    editSelectedRole,
    copyrole,
    fetchRoles
  } = props;
  const { addRoleFields } = FORMDATA;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  // const { addRoleLoading } = useSelector((state: any) => state?.roleTable);

  const dispatch = useDispatch<AppDispatch>();

  // If form gets successfully submitted
  const onFinish = (values: any) => {
    const trimmedRoleName = (values?.roleName || "").trim();
    const trimmedRoleDescription = (values?.roleDescription || "").trim();
  
    values.roleName = trimmedRoleName;
    values.roleDescription = trimmedRoleDescription;
  
    setIsLoading(true); // 🔥 This should trigger the spinner
  
    if (editSelectedRole) {
      if (!copyrole) {
        const data = {
          roleId: editSelectedRole?.id,
          roleName: values?.roleName,
          roleDescription: values?.roleDescription,
        };
        dispatch(editRoleActionTable(data)).then((res: any) => {
          if (res?.payload?.response?.responseStatus === 200) {
            toastText(res?.payload?.response?.message, 'success');
          }
        }).finally(() => {
          fetchRoles();
          setIsLoading(false);
          closeDrawerByAnimation();
        });
      } else {
        const data = {
          cloneRoleId: editSelectedRole?.id,
          roleName: values?.roleName,
          roleDescription: values?.roleDescription
        };
        dispatch(cloneRoleActionTable(data)).then((res: any) => {
          if (res?.payload?.response?.responseStatus === 200) {
            toastText(res?.payload?.response?.message, 'success');
          } else {
            toastText(res?.payload?.message, 'error');
          }
        }).finally(() => {
          fetchRoles();
          setIsLoading(false);
          closeDrawerByAnimation();
        });
      }
    } else {
      dispatch(addRoleActionTable(values))
        .then((res: any) => {
          if (res?.payload?.responseStatus === 200) {
            toastText(res?.payload?.message, 'success');
          } else {
            toastText(res?.payload?.message, 'error');
          }
        }).finally(() => {
          fetchRoles();
          closeDrawerByAnimation();
          setIsLoading(false);
        });
    }
;
  };
  

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className={styles["side-drawer-body"]}>
      <Form
        form={form}
        name="basic"
        initialValues={editSelectedRole}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
        labelAlign="left"
        className={styles["side-drawer-form"]}
      >
        <div className={styles["side-drawer-form__inputs"]}>
          {addRoleFields.map((singleField, index) => {
            return (
              <div
                key={index}
                className={styles["side-drawer-form__single-input"]}
              >
                <label
                  className={styles["side-drawer-form__single-input--label"]}
                >
                  {singleField?.title}{" "}
                  {singleField?.required && (
                    <span className="required-color">*</span>
                  )}
                </label>
                {singleField.type === "textArea" ? (
                  <Form.Item
                    name={singleField.name}
                    className={`${styles["side-drawer-form__single-input--input"]} text-area-error`}
                    rules={singleField.rules as []}
                  >
                    <textarea
                      className={
                        styles["side-drawer-form__single-input--textarea"]
                      }
                      placeholder={singleField.placeholder}
                    />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name={singleField.name}
                    className={styles["side-drawer-form__single-input--input"]}
                    rules={singleField.rules as []}
                  >
                    <Input
                      placeholder={singleField.placeholder}
                      size="large"
                      type={singleField.type}
                    />
                  </Form.Item>
                )}
              </div>
            );
          })}
        </div>
        <div className={styles['side-drawer-form__buttons']}>
          <Button
            htmlType="submit"
            className={styles['side-drawer-form__buttons--edit']}
            loading={isLoading}
          >
            {editSelectedRole ? copyrole ? "clone" : 'Edit' : 'Save'}
          </Button>

          <Button
            htmlType="reset"
            className={styles['side-drawer-form__buttons--cancel']}
            onClick={closeDrawerByAnimation}
            disabled={isLoading}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddRoleBody;
